import { useTable } from '@composables/common'
import { OrderDocument } from '@src/types'
import { useUserStore } from '@src/utils/stores/user'
import { Ref, computed } from 'vue'

export function useOrderDocumentsTable(orderDocuments: Ref<OrderDocument[]>) {
    const userStore = useUserStore()

    const total = computed(() => {
        return orderDocuments.value.length
    })
    const { TableWrapper: OrderDocumentsTable } = useTable({
        tableProps: {
            data: orderDocuments,
            total: total,
            label: 'order_documents',
            id: 'order_documents_table',
            help: 'help_order_documents_table',
            columns: [
                {
                    label: 'id',
                    key: 'id',
                    url: documentURL,
                    targetBlank: true,
                    sorting: false,
                    condition: userStore.can('see_id_columns'),
                    copy: true,
                },
                {
                    label: 'name',
                    key: 'name',
                    url: documentURL,
                    targetBlank: true,
                    sorting: false,
                    copy: true,
                },
            ],
            actions: [
                {
                    action: handleOpenInNewTab,
                    icon: 'fa-eye',
                    title: 'view_document',
                },
            ],
        },
    })

    function documentURL(document: OrderDocument) {
        return document.url
    }

    function handleOpenInNewTab(rowData: OrderDocument) {
        const url = rowData.url
        window.open(url, '_blank')
    }

    return {
        OrderDocumentsTable,
    }
}
